export default "__VITE_ASSET__Ddiq_oJJ__"